import createReduxConstants from 'app/helpers/redux/createReduxConstants';

export const HIDDEN_NOTICES_COOKIE = 'hidden_notices';

export default createReduxConstants('NOTICE', {
  DISMISS_NOTICE: null
});
